import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { getAcceptLanguage } from "./utils/acceptLanguage";
import { applyDocumentLanguage } from "./utils/documentLang";
import en from "./locales/en.json";
import ar from "./locales/ar.json";

const initialLng = getAcceptLanguage();
applyDocumentLanguage(initialLng);

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    ar: { translation: ar },
  },
  lng: initialLng,
  fallbackLng: "en",
  interpolation: { escapeValue: false },
  returnNull: false,
});

i18n.on("languageChanged", (lng) => {
  applyDocumentLanguage(lng);
});

export default i18n;
